import { Box, Grid } from "@mui/joy";
import React from "react";
import BuildingList, { Building } from "./BuildingList";
import BuildingPage from "./BuildingPage";
import BuildingHeader from "../GenericComponents/BuildingHeader";
import { useParams } from "react-router-dom";


interface BuildingPortalProps {}

// localStorage key for persisting selected building
const BUILDING_STORAGE_KEY = "selectedBuildingId";

export default function BuildingPortal(props: BuildingPortalProps) {
	const [selected, setSelected] = React.useState(null as any as Building);
	const [hideList, setHideList] = React.useState(false);
	const u = useParams()["*"];

	// Get the default building ID - URL param takes priority, then localStorage
	const getDefaultBuildingId = (): string | undefined => {
		if (u) return u;
		return localStorage.getItem(BUILDING_STORAGE_KEY) || undefined;
	};

	const selectBuilding = (b: Building) => {
		setSelected(b);
		// Persist selected building to localStorage
		if (b?.ID) {
			localStorage.setItem(BUILDING_STORAGE_KEY, b.ID);
		}
	};

	return (
		<Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
			{selected && <BuildingHeader buildingId={selected.ID} />}
			<Grid container sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
				<Grid xs={hideList ? 0 : 2} sx={{ overflowY: "auto", minHeight: 0, height: "100%", p: 1 }}>
					<BuildingList hide={() => setHideList(true)} selectBuilding={selectBuilding} defaultBuilding={getDefaultBuildingId()} selectedBuildingId={selected?.ID} />
				</Grid>
				<Grid xs={hideList ? 12 : 10} sx={{ overflow: "hidden", minHeight: 0, height: "100%", display: "flex", flexDirection: "column", flex: 1 }}>
					{selected && <BuildingPage BuildingID={selected.ID} />}
				</Grid>
			</Grid>
		</Box>
	);
}

